// Deletes cookies by name on both the current host and the registrable parent domain.
// Clarity (`_clck`/`_clsk`) and GA4 (`_ga*`) set cookies on the registrable domain so
// subdomains (www ↔ hub) share them, so clearing must target that domain too. Pure over an
// injected document + host — unit-testable without the DOM.
export function deleteCookies(
  names: string[],
  doc: Pick<Document, 'cookie'> = document,
  host: string = typeof location === 'undefined' ? '' : location.hostname,
): void {
  const parent = registrableParent(host);
  for (const name of names) {
    doc.cookie = `${name}=; Max-Age=0; path=/`;
    if (parent) doc.cookie = `${name}=; Max-Age=0; path=/; domain=${parent}`;
  }
}

// `.cloudhouse.com` for `hub.cloudhouse.com`; null for single-label hosts (localhost).
// Assumes a single-label public suffix (.com). A host under a two-label suffix such as
// .co.uk would need the public-suffix list to find its registrable domain.
function registrableParent(host: string): string | null {
  const labels = host.split('.').filter(Boolean);
  if (labels.length < 2) return null;
  return '.' + labels.slice(-2).join('.');
}
